import { Copy, Plus } from 'lucide-react';
import { useState } from 'react';

import { AddPromptForm } from './AddPrompt';
import { ClonePromptForm } from './ClonePrompt';
import { PromptsFilter } from './PromptsFilter';
import { PromptsTable } from './PromptsTable';

import { Button } from '@/components/ui/Button';
import { Card, CardContent } from '@/components/ui/Card';

export function PromptsPage() {
  const [filter, setFilter] = useState<{
    serviceName?: string;
    promptName?: string;
  }>({});

  const [showPromptForm, setShowPromptForm] = useState(false);
  const [showClonePromptForm, setShowClonePromptForm] = useState(false);

  return (
    <div className="container mx-auto py-4">
      <div className="mb-6 flex items-center justify-between gap-4">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">
            Prompt Templates
          </h2>
          <p className="mt-1 text-gray-600">
            Manage versioned prompt templates with variables
          </p>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            className="gap-2"
            onClick={() => setShowClonePromptForm(true)}
          >
            <Copy className="h-4 w-4" />
            Clone Prompt
          </Button>
          <Button className="gap-2" onClick={() => setShowPromptForm(true)}>
            <Plus className="h-4 w-4" />
            Add New Prompt
          </Button>
        </div>
      </div>
      <Card className="mb-6">
        <CardContent className="p-4">
          <PromptsFilter onFilterChange={setFilter} filter={filter} />
        </CardContent>
      </Card>
      <PromptsTable filter={filter} />

      <AddPromptForm
        open={showPromptForm}
        onClose={() => setShowPromptForm(false)}
      />

      <ClonePromptForm
        open={showClonePromptForm}
        onClose={() => setShowClonePromptForm(false)}
      />
    </div>
  );
}
